module.exports = __webpack_public_path__ + "static/media/vacuum-robot.660e02e1.svg";